/**
 * BET-289 S2: Format field-level writing guidance into a prompt section.
 * Replicated from convex/lib/formatFieldGuidance.ts due to monorepo import boundary (BR-170).
 * Must produce identical output to the convex/ version.
 *
 * Pure function (STD-148). No side effects, no imports beyond types.
 */

export interface FieldWithGuidance {
	key: string;
	label?: string;
	writingGuidance?: string;
	writingExamples?: string[];
}

/**
 * Format field-level writing guidance into a prompt-injectable section.
 *
 * @param fields - Array of field definitions, potentially with writingGuidance/writingExamples.
 * @returns Formatted string for prompt injection, or empty string if no fields have guidance.
 */
export function formatFieldGuidance(fields: FieldWithGuidance[]): string {
	const guidedFields = fields.filter((f) => f.writingGuidance);
	if (guidedFields.length === 0) return '';

	const lines: string[] = ['## Writing Guidance'];
	for (const field of guidedFields) {
		const displayName = field.label || field.key;
		lines.push(`- ${displayName}: ${field.writingGuidance}`);
		if (field.writingExamples && field.writingExamples.length > 0) {
			lines.push(`  Examples: ${field.writingExamples.join(' | ')}`);
		}
	}

	return lines.join('\n');
}
